import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SettingsTabs, { type SettingsTab } from '../components/settings/SettingsTabs';
import SecurityTab from '../components/settings/SecurityTab';
import StorageTab from '../components/settings/StorageTab';
import SyncTab from '../components/settings/SyncTab';
import DeveloperTab from '../components/settings/DeveloperTab';
import BuildInfo from '../components/settings/BuildInfo';

const VALID_TABS: SettingsTab[] = ['security', 'storage', 'sync', 'developer'];

/**
 * Settings page - Multi-tab interface for security and storage settings
 */
export default function Settings() {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') as SettingsTab | null;
  const initialTab = tabParam && VALID_TABS.includes(tabParam) ? tabParam : 'security';
  const [activeTab, setActiveTab] = useState<SettingsTab>(initialTab);

  return (
    <div className="px-6 py-6">
      <h1 className="font-heading text-2xl text-black mb-8">Settings</h1>

      <SettingsTabs activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === 'security' && <SecurityTab />}
      {activeTab === 'storage' && <StorageTab />}
      {activeTab === 'sync' && <SyncTab />}
      {activeTab === 'developer' && <DeveloperTab />}

      <BuildInfo />
    </div>
  );
}
